import { Injectable } from '@angular/core';

import { FullClientInterface, IdInterface } from '../data';
import { MemoryMapCacheRepository } from './memory-map-cache.repository';

@Injectable()
export class FullClientCacheRepository extends MemoryMapCacheRepository<FullClientInterface> {
    getKey(clientCode: IdInterface): string {
        return 'FullClientCacheRepository' + String(clientCode);
    }
}
